import { map, Observable, tap, lastValueFrom, catchError, throwError } from 'rxjs';

import { DatePipe } from '@angular/common';
import { EventEmitter, Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { User } from 'src/app/models/user';
import { Race, RaceClass, TrackerData, TrackerPoint } from 'src/app/models';
import { UserGpsData } from 'src/app/models/interfaces/tracker_point.interface';
import { RaceProgress } from '../models/race_progress';
import { SocketService } from './socket.service';
import { ServerResponse } from '../response';
import { MapDomainService } from '../domains/map.service';
import { RaceProgressRegistrations } from 'src/app/models/types';
import { RaceProgressRegistration } from '../models';
import { TrackerService } from './tracker.service';
import { ColorsService } from './colors.service';
import { ProtocolDomainService } from '../domains/protocol.service';

const SUBSCRIBE = 'subscribe';
const UNSUBSCRIBE = 'unsubscribe';
const GPS = 'gps';
@Injectable({
  providedIn: 'root',
})
export class MapService {

  time_states: Array<SelectItem> = [
    { label: 'timePoint', value: 1 },
    { label: 'timePrevPoint', value: 2 },
    { label: 'timeStartPoint', value: 3 },
    { label: 'timeStartUser', value: 4 },
    { label: 'timeDeltaLeader', value: 5 },
  ];

  // отображать ли все приходящие точки или нет. Не будет срабатывать условие по дальности от гонки, если тру
  showAllpoints = false;


  eventUserInfo: EventEmitter<User> = new EventEmitter();
  // Эвент загрузки события
  trackLoad: EventEmitter<RaceProgressRegistration> = new EventEmitter();
  // Выбрали отображать трек у участника
  competitorSelectChange: EventEmitter<RaceProgressRegistration> = new EventEmitter();
  // выбрали всех или нет
  selectAllModeChange: EventEmitter<boolean> = new EventEmitter(); // Сначала нужно изменить значения в картах
  selectAllModeMapChange: EventEmitter<boolean> = new EventEmitter(); // Потом отрисовать в треках

  showTrackEvent: EventEmitter<RaceProgressRegistration> = new EventEmitter();
  hideTrackEvent: EventEmitter<RaceProgressRegistration> = new EventEmitter();

  // событие что отрисовали трек
  createSectionEvent: EventEmitter<void> = new EventEmitter();

  showToolbarEvent: EventEmitter<boolean> = new EventEmitter();

  scrollToUserEvent: EventEmitter<RaceProgressRegistration> = new EventEmitter();

  // событие добавления новой карты в текущий выбранный класс
  newMap: EventEmitter<string> = new EventEmitter();
  showHideNewMap: EventEmitter<void> = new EventEmitter();

  // Событие получения данных по gps
  updateTrackerDataEvent: EventEmitter<{ competitor: RaceProgressRegistration; event: (trackerData: TrackerData) => void }> = new EventEmitter();

  raceProgress!: RaceProgress;

  // Список участников по классу с треками
  private competitors: RaceProgressRegistrations = {};
  private competitors_keys: string[] = [];
  private limitDistancePoint = 500;

  // лимит разрыва участка. В метрах?
  // private distanceLimit = 0.0005;
  private distanceLimit = 0.0005;

  constructor(
    private socketService: SocketService,
    private datePipe: DatePipe,
    private mapDomainService: MapDomainService,
    private trackerService: TrackerService,
    private colorsService: ColorsService,
    private protocolDomainService: ProtocolDomainService
  ) {
    // Подписываемся заново на данные после реконнекта
    this.socketService.reloadEvent.subscribe(() => {
      this.competitors_keys.forEach((key) => {
        this.subscribeTrackInfo(this.competitors[key]);
      });
    });

    // А это какой-то трекер выгрузил данные.
    this.socketService.addListener(GPS, ({ uid, lat, lon, time, bat, version }: UserGpsData) => {
      // if (uid) {
      //   const competitor = this.competitors[uid];
      //   const trackerData = this.trackerService.getTracker(uid);
      //   if (!trackerData) {
      //     this.updateTrackerDataEvent.emit({
      //       competitor,
      //       event: (trackerData: TrackerData) => {
      //         if (competitor && trackerData && time < trackerData.finGPStime) {
      //           const competitorPosition = this.updatePoints(competitor, [{ lat, lon, time, bat: bat ? Number(bat) : undefined, version: version ? Number(version) : undefined }]);
      //           this.trackLoad.emit(competitorPosition);
      //         }
      //       },
      //     });
      //   }
      //   if (competitor && trackerData && time < trackerData.finGPStime) {
      //     const competitorPosition = this.updatePoints(competitor, [{ lat, lon, time, bat: bat ? Number(bat) : undefined, version: version ? Number(version) : undefined }]);
      //     this.trackLoad.emit(competitorPosition);
      //   }
      // }
    });
  }

  timezoneOffsetToString(offsetInMinutes: number): string {
    const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
    const minutes = Math.abs(offsetInMinutes) % 60;

    const sign = offsetInMinutes >= 0 ? '+' : '-';
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${sign}${formattedHours}${formattedMinutes}`;
  }

  /**
   * Выставляем цвет и по умолчанию выбираем для отображения маркера участника
   * @param competitor
   * @param position
   * @param classObject
   */
  updateCompetitorPosition(competitor: RaceProgressRegistration, position: TrackerData, classObject: any): RaceProgressRegistration {
    const cUid = competitor.registration.user.cUid;
    position.numberColor = this.colorsService.generateUniqueColor(classObject.clUid);
    position.numberActive = true;
    // Обновляем в TrackerService
    this.trackerService.updateTracker(cUid, position);
    return competitor;
  }

  // Изменили выбор списка участников в классе для отображэения
  selectCompetitor(competitor: RaceProgressRegistration) {
    this.competitorSelectChange.emit(competitor);
  }

  updatePoints(competitor: RaceProgressRegistration, data: TrackerPoint[]): RaceProgressRegistration {
    const cUid = competitor.registration.user.cUid;
    const trackerData = this.trackerService.getTracker(cUid);
    if (!trackerData) {
      return competitor;
    }

    if (!trackerData.points) {
      trackerData.points = {};
    }

    const points = trackerData.points;
    const datePoint = new Date();
    data.forEach((item) => {
      if (item && item.time !== undefined) {
        // Выкидываем точки которые очень далеко от координат города проведения гонки
        if (!this.showAllpoints) {
          if (Math.abs(item.lat - this.raceProgress.race.location.latitude) > 3 || Math.abs(item.lon - this.raceProgress.race.location.longitude) > 3) {
            return;
          }
        }
        // выкидываем точки которые по времени не в дату гонки
        datePoint.setTime(item.time);
        if (this.datePipe.transform(datePoint, 'yyyy-MM-dd') !== this.datePipe.transform(this.raceProgress.race.date, 'yyyy-MM-dd')) {
          return;
        }

        let gpsData = item;
        if (gpsData.time !== undefined) {
          points[gpsData.time] = gpsData;
          if (!trackerData.minTime || gpsData.time < trackerData.minTime) {
            trackerData.minTime = gpsData.time;
          }

          if (!trackerData.maxTime || gpsData.time > trackerData.maxTime) {
            trackerData.maxTime = gpsData.time;
          }
        }
      }
    });

    trackerData.pointsKeys = Object.keys(points)
      .map((key) => Number(key))
      .sort((a, b) => a - b);

    // Обновляем трекер в сервисе
    this.trackerService.updateTracker(cUid, trackerData);

    // this.calcMetadataPoints(trackerData);
    return competitor;
  }

  // Высчитываем данные по треку
  calcMetadataPoints(trackerData: TrackerData, lastI: number): {
    distance: number,
    maxSpeed: number,
    diffSpeed: number,
  } {
    let distance = 0;
    let diffSpeedArr: number[] = [];
    let diffSpeed = 0;
    let maxSpeed = 0;
    let prevPoint: TrackerPoint | undefined = undefined;

    for (let i = 0; i < lastI; ++i) {

      const key = trackerData.pointsKeys[i];
      if (key === undefined) continue;
      const pointValue = trackerData.points[key];
      if (!pointValue) continue;
      let point: TrackerPoint = pointValue;

      if (!prevPoint) {
        prevPoint = point;
        continue;
      }
      point = this.calcMetadata(point, prevPoint);

      prevPoint = point;
      if (point.distance) {
        distance = distance + point.distance;
      }
      if (point.currentSpeed) {
        if (maxSpeed < point.currentSpeed) {
          maxSpeed = point.currentSpeed;
        }
        diffSpeedArr.push(point.currentSpeed);
      }
    };

    // считаем среднюю скорость
    if (diffSpeedArr.length) {
      diffSpeed =
        diffSpeedArr.reduce((prev, current) => {
          return current + prev;
        }) / diffSpeedArr.length;
    }

    return {
      distance,
      maxSpeed,
      diffSpeed,
    };
  }

  /**
   * Высчитываем данные между точками
   * @param currentGpsData
   * @param prevGpsData
   */
  calcMetadata(currentGpsData: TrackerPoint, prevGpsData: TrackerPoint | undefined): TrackerPoint {
    if (prevGpsData && currentGpsData.time !== undefined && prevGpsData.time !== undefined) {
      currentGpsData.distance = this.getDistanceKm(prevGpsData.lat, prevGpsData.lon, currentGpsData.lat, currentGpsData.lon);
      currentGpsData.deltaTime = (currentGpsData.time - prevGpsData.time) / 3600000;
      currentGpsData.currentSpeed = currentGpsData.distance / currentGpsData.deltaTime;
    } else {
      currentGpsData.distance = 0;
      currentGpsData.deltaTime = 0;
      currentGpsData.currentSpeed = 0;
    }
    return currentGpsData;
  }

  /**
   * Опеределение расстояния между точками
   * @private
   * @param lat1
   * @param lon1
   * @param lat2
   * @param lon2
   */
  private getDistanceKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const earthRadiusKm = 6371;

    const dLat = this.degreesToRadians(lat2 - lat1);
    const dLon = this.degreesToRadians(lon2 - lon1);

    const radLat1 = this.degreesToRadians(lat1);
    const radLat2 = this.degreesToRadians(lat2);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(radLat1) * Math.cos(radLat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadiusKm * c;

    return distance;
  }

  degreesToRadians(degrees: number): number {
    return (degrees * Math.PI) / 180;
  }

  // Заполняем competitors только с трекерами
  initCompetitors(competitors: RaceProgressRegistration[]) {
    // отписываемся от всех
    this.competitors_keys.forEach((key) => {
      this.unsubscribeTrackInfo(this.competitors[key]);
    });

    const competitorsPosition = competitors.filter((competitor) => {
      const trackerData = this.trackerService.getTracker(competitor.registration.user.cUid);
      return trackerData?.gpsTracker;
    });

    // заполняем массив и подписываемся на изменения в треках.
    this.competitors = {};
    competitorsPosition.forEach((competitorPosition) => {
      const trackerData = this.trackerService.getTracker(competitorPosition.registration.user.cUid);
      if (trackerData) {
        this.competitors[competitorPosition.registration.user.cUid] = competitorPosition;
        this.subscribeTrackInfo(competitorPosition, trackerData);
      }
    });
    this.competitors_keys = Object.keys(this.competitors);
  }

  /**
   * Получение списка участников в виде массива выбранных для отображения
   */
  getCompetitorsPosition(): RaceProgressRegistration[] {
    return this.competitors_keys.map((key) => this.competitors[key]).filter((competitor) => {
      const trackerData = this.trackerService.getTracker(competitor.registration.user.cUid);
      return trackerData?.numberActive;
    });
  }

  // Получение списка участников в виде массива всех
  getCompetitorsAllPosition(): RaceProgressRegistration[] {
    return this.competitors_keys.map((key) => this.competitors[key]);
  }

  // Высчитываем длительность гонки по данным trackerData выбранных участников
  calculateMaxTime(competitors: RaceProgressRegistration[]): { raceTime: number; raceDateTime: Date | null } {
    let minTimeRace: number | undefined = undefined;
    let maxTimeRace: number | undefined = undefined;
    competitors.forEach((competitor) => {
      const trackerData = this.trackerService.getTracker(competitor.registration.user.cUid);
      if (trackerData) {
        const startTime = trackerData.minTime;
        const maxTime = trackerData.maxTime;
        if (!startTime || !maxTime) {
          return;
        }

        if (!minTimeRace || startTime < minTimeRace) {
          minTimeRace = startTime;
        }

        if (!maxTimeRace || maxTime > maxTimeRace) {
          maxTimeRace = maxTime;
        }
      }
    });

    if (maxTimeRace && minTimeRace) {
      let raceTime = maxTimeRace - minTimeRace;
      let raceDateTime: Date | null = null;

      if (raceTime !== 0) {
        raceDateTime = new Date();
        raceDateTime.setTime(minTimeRace);
      }
      return { raceTime, raceDateTime };
    } else {
      return { raceTime: 0, raceDateTime: null };
    }
  }

  subscribeTrackInfo(gpsPosition: RaceProgressRegistration, trackerData?: TrackerData): void {
    const cUid = gpsPosition.registration.user.cUid;
    const td = trackerData || this.trackerService.getTracker(cUid);
    if (td) {
      this.socketService.send(SUBSCRIBE, [td.gpsTracker]);
    }
  }

  unsubscribeTrackInfo(gpsPosition: RaceProgressRegistration): void {
    const trackerData = this.trackerService.getTracker(gpsPosition.registration.user.cUid);
    this.socketService.send(UNSUBSCRIBE, [trackerData?.gpsTracker]);
  }

  /**
   * Сохранение позиции и uid куска карты для класса
   * @param uid
   * @param bounds
   * @param clUid
   */
  newMapLayerPosition(customMapFileUid: string, bounds: number[][], clUid: string, rUid: string): Observable<ServerResponse<void>> {
    return this.mapDomainService.newMapLayerPosition(customMapFileUid, bounds, clUid, rUid)
      .pipe(map(() => ({ status: 'OK', data: undefined } as unknown as ServerResponse<void>)));
  }

  /**
   * Создание маркеров маршалов по GPS точкам трекеров
   * @param rUid uid гонки
   * @param clUid uid класса
   * @param trackers массив трекеров { cUid, trackers[] }
   */
  createMarshalMarksByGps(rUid: string, clUid: string, trackers: { cUid: string; trackers: string[] }[]): Observable<ServerResponse<void>> {
    return this.mapDomainService.createMarshalMarksByGps(rUid, clUid, trackers)
      .pipe(map(() => ({ status: 'OK', data: undefined } as unknown as ServerResponse<void>)));
  }

  /**
   * Забираем треки все
   * @param gpsPosition
   */
  fillTracksInfo(gpsPosition: RaceProgressRegistration, timestampStart: string | null = null, timestampEnd: string | null = null): Promise<void> {
    const cUid = gpsPosition.registration.user.cUid;
    const trackerData = this.trackerService.getTracker(cUid);
    if (!trackerData) {
      return Promise.resolve();
    }

    const trackRequest = {
      uid: trackerData.gpsTracker,
      cuid: cUid,
      timestampStart: timestampStart ? timestampStart : this.getTimeStampDateForPSQL(trackerData.startGPStime),
      timestampEnd: timestampEnd
        ? timestampEnd
        : this.getTimeStampDateForPSQL(trackerData.finGPStime ? trackerData.finGPStime + 10 * 1000 : null),
      distanceLimit: this.distanceLimit,
    };
    trackerData.loading = true;
    return lastValueFrom(
      this.mapDomainService.getTrack(trackRequest)
        .pipe(
          map((data) => {
            const competitor = this.competitors[data.uid];
            const competitorPosition = this.updatePoints(
              competitor,
              data.points.map(({ lat, lon, timestamp, bat, version }) => {
                return { lat, lon, time: timestamp, bat: bat ? Number(bat) : undefined, version: version ? Number(version) : undefined };
              })
            );
            const updatedTrackerData = this.trackerService.getTracker(data.uid);
            if (updatedTrackerData) {
              if (!updatedTrackerData.reconnectData) {
                updatedTrackerData.tracksLoaded = true;
              } else {
                updatedTrackerData.reconnectData = false;
              }
            }
            this.trackLoad.emit(competitorPosition);
          })
        )
    );
  }

  /**
   * формат времени для msm
   * @param time
   */
  getTimeStampDateForPSQL(time: number | null): string | null {
    const date = new Date();
    if (time && time > 0) {
      date.setTime(time);
    }
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss', '+0000');
  }

  /**
   * Обновить трекеры из TrackerService
   */
  updateTrackers(trackers: Map<string, TrackerData>): void {
    // Для совместимости можно обновлять trackerData в competitors при необходимости
    // В данный момент trackerData хранится только в TrackerService
  }

  getRaceProgress(rUid: Race['rUid'], clUid: RaceClass['clUid'] | undefined = undefined): Observable<RaceProgress> {
    return this.protocolDomainService.getNewProgress(rUid, clUid);
  }
}
